export const GET_ROCKETS = 'store/rockets/GET_ROCKETS';
export const RESERVE_ROCKET = 'store/rockets/RESERVE_ROCKET';
